
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


type canDeactivateType = Observable<boolean> | Promise<boolean> | boolean;

export interface CanComponentDeactivate {
  canDeactivate: () => canDeactivateType;
}

@Injectable({ providedIn: 'root' })

export class DiscardChanges  {

  public canDeactivate(component: CanComponentDeactivate): canDeactivateType {
    return component?.canDeactivate ? component.canDeactivate() : true;
  }

}
